import { type HTMLAttributes } from "react";

import { CSSObject } from "@emotion/react";

import { tableDescriptionCss } from "./TableDescription.styles";

interface TableDescriptionProps extends HTMLAttributes<HTMLHeadingElement> {
  description?: string | undefined;
  css?: CSSObject;
}

const TableDescription = (props: TableDescriptionProps) => {
  const { description, ...passedFromAngelou } = props;
  return (
    <div
      {...passedFromAngelou}
      css={[passedFromAngelou.css, tableDescriptionCss]}
    >
      {description}
    </div>
  );
};

export default TableDescription;
